'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ChevronUp = {};

exports.__exports = ChevronUp;
